export function ScreenCheck(mediaWidth: number) {
    let mediaQuery = window.matchMedia(`(max-width: ${mediaWidth - 1}px)`)
    if (mediaQuery.matches) {
        return false;
    } else {
        return true;
    }
}